import React from 'react';

import styles from './index.module.scss';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';

const textContent = [
  {
    key: '1',
    textTitle: `I. Introduction.`,
    content: (
      <>
        Tipping Guide LLC, its owners, affiliates, partners, and subsidiaries
        (collectively, “we”, “our”, “us”, “the Company”, or “Tipping Guide”) are
        committed to protecting your (“you”, “your”, or the “User”) privacy
        rights and personal information while you are using our products and
        services, and we’d like you to understand how we collect, store, use,
        and disclose your personal information.
        <br />
        <br /> This Privacy Policy, which should be read and understood in
        conjunction with the Company’s Terms of Service, located at{' '}
        <a href="/terms-and-conditions">Terms of Service</a>, applies when you
        interact with or use, without limitation, the Company’s websites,
        platforms, or applications (mobile or otherwise) (collectively, the
        “Site”), as well as the Company’s social media interactions, products,
        services, or otherwise (collectively, with the Site, the “Services”) in
        any manner, and when you interact with any Company personnel with
        respect to the Services. By using the Services, or by interacting with
        Company personnel, you agree to both the terms herein and those included
        in the Company’s Terms of Service (collectively, the “Agreement”).
        <br />
        <br />
        <h3>
          IF YOU DO NOT AGREE TO ABIDE BY THE DATA PRACTICES DESCRIBED IN THIS
          PRIVACY POLICY OR TO THE TERMS SPECIFIED IN THE TERMS OF SERVICE, THEN
          PLEASE CLOSE YOUR BROWSER, APP, OR DEVICE IMMEDIATELY AND DO NOT USE
          OR ACCESS THE SERVICES.
        </h3>
      </>
    ),
  },
  {
    key: '2',
    textTitle: `II. Personal Information We Collect.`,
    content: (
      <>
        When you visit the Site, we may collect certain information about your
        device, including your IP address, browser type, operating system, and
        referring pages. We also collect information about the pages you visit
        on the Site and the actions you take on the Site (such as clicking on
        links).
        <br />
        <br />
        The way we process your personal information may also depend on the
        particular Services, functionalities, or experiences you use, your
        location, and applicable law.
      </>
    ),
  },
  {
    key: '3',
    textTitle: `III. Information You Provide to Us.`,
    content: (
      <>
        <strong>
          Communications, feedback and survey data, and related data.
        </strong>{' '}
        When you create an account with us, reach out to us for support, give us
        feedback, participate in optional surveys, participate in product
        research, or otherwise interact or communicate with us, we may collect
        personal information, such as your name, email address, birth year,
        country, zip code, etc., and any other personal information you choose
        to share.
        <br /> <br />
        <strong>Marketing data.</strong> You may provide us with your contact
        information and preferences for receiving our marketing communications.
        <br /> <br />
        <strong>Device and contact data.</strong> If you grant permission in
        your device settings, certain features may have access to your device
        and contacts.
      </>
    ),
  },
  {
    key: '4',
    textTitle: `IV. Automatic Data Collection.`,
    content: (
      <>
        We may automatically log personal information about you, your computer,
        or mobile device, and your interaction over time with the Services, such
        as:
        <br />
        <br />
        <ul>
          <li>
            <strong>Device information:</strong> We may collect information
            about your device(s), such as IP addresses, log information, error
            messages, device type, and unique device identifiers. For example,
            we may collect IP addresses from you as part of our sign in and
            security features.
          </li>
          <li>
            <strong>Usage information:</strong> We may collect information about
            your use of the Services, such as the pages you viewed, the services
            and features you used or interacted with, your browser type, and
            details about any links or communications with which you interacted.
          </li>
          <li>
            <strong>Information stored locally:</strong> Some of our web-enabled
            services and offerings may synchronize with the information on your
            computer. In doing so, we may collect information such as device
            information, product usage, and error reports. We may also store
            personal information locally on your device.
          </li>
          <li>
            <strong>Communication interaction data:</strong> We or our
            third-party service providers may collect information from email
            providers, communication providers, and social networks, such as
            your interactions with our email, text, or other communications.
          </li>
          <li>
            <strong>Online behavioral data:</strong> We may automatically
            collect certain personal information about your use and interactions
            with our website, mobile applications, social media websites, and
            marketing campaigns that we or our partners organize, including
            device information, page view information, and search results.
          </li>
        </ul>
      </>
    ),
  },
  {
    key: '5',
    textTitle: `V. How We Use Your Personal Information.`,
    content: (
      <>
        We use the information we collect from you to, for example, and without
        limitation:
        <br />
        <br />
        <ul>
          <li>Provide the Site, Services, and their features;</li>
          <li>Run and manage our business;</li>
          <li>Communicate with you;</li>
          <li>
            Offer you targeted advertising, and otherwise evaluate your
            eligibility for marketing offers, products, and services;
          </li>
          <li>Track the use of the Site;</li>
          <li>Improve the Site and our products and services;</li>
          <li>Provide you with support and resolve disputes;</li>
          <li>Authenticate your identity, if necessary; and</li>
          <li>Comply with applicable laws and regulations.</li>
        </ul>
        <br />
        Beyond that, we may further use your information to improve and develop
        our Services by analyzing how they are used and interacted with,
        assessing your use of and interactions with our Services and certain
        content, and conducting data analytics to develop insights about you,
        your needs, and your preferences.
        <br />
        <br />
        We may also combine and anonymize information about your interactions
        with us to create aggregate statistics for research, marketing,
        promotion, improvement, and development of our Site and Services.
        <br />
        <br />
        Additionally, we, our service providers, and our third-party advertising
        partners may collect and use your personal information for marketing and
        advertising purposes to (i) market services, products, and experiences,
        as well as other, non-transactional communications via email, post,
        telephone, SMS, or push notifications, in accordance with your marketing
        preferences; and (ii) personalize your experience and tailor
        recommendations, advertising, and offers presented to you, including
        through the development of insights about you and your needs based on
        your interactions with the Site and Services.
        <br />
        <br />
        Finally, we may use your personal information for compliance and
        protection issues, including, without limitation, to: (i) protect
        against misuse or abuse of our Services and ensure compliance with our
        Terms of Service; (ii) comply with legal and regulatory requirements;
        (iii) protect the rights, property, safety, or security of the Site, our
        customers, employees, or others, and prevent fraudulent or illegal
        activity; (iv) exercise our rights in the course of judicial,
        administrative, or arbitration proceedings; and (v) enforce, remedy, or
        apply our Terms of Service or other agreements.
      </>
    ),
  },
  {
    key: '6',
    textTitle: `VI. Sharing Your Personal Information.`,
    content: (
      <>
        We may share your personal information with third parties to help us use
        your information as described above. We may also share your personal
        information to comply with applicable laws and regulations, to respond
        to a subpoena, search warrant, or other lawful request for information
        we receive, or to protect our rights.
        <br />
        <br />
        Additionally, we may use advertising networks and other providers to
        display advertising on our Site or to manage our advertising on other
        sites. Our advertising partners may place Cookies (hereinafter defined)
        on affiliated or unaffiliated websites in order to serve advertisements
        that may be relevant to you based on your browsing activities and
        interests and determine the effectiveness of such advertisements.
        <br />
        <br />
        We may also share your personal information with third parties for legal
        reasons without your consent, including (i) when we reasonably believe
        disclosure is required in order to comply with a subpoena, court order,
        or other applicable law, regulation, or legal process; (ii) to protect
        the rights, property, or safety of the Company, the Services, Site, our
        customers, or others; (iii) to enforce, remedy, or apply our Privacy
        Policy, Terms of Service, or other agreements; (iv) to prevent fraud,
        cybersecurity attacks, or illegal activity, or to protect or defend
        against same; (v) with regulatory agencies, including government tax
        agencies, as necessary to help detect and combat fraud and/or protect
        our customers, users, and/or the Site, or in required institutional risk
        control programs.
      </>
    ),
  },
  {
    key: '7',
    textTitle: `VII. Cookies.`,
    content: (
      <>
        We may use commonly used tools, such as cookies, web beacons, pixels,
        local shared objects, and similar technologies{' '}
        <strong>(collectively, “Cookies”)</strong>, to collect information about
        you <strong>(“Cookie Information”)</strong> so that we can provide the
        experiences you request, recognize your visit, track your interactions,
        and improve your and other customers’ experiences. You have control over
        some of the information we collect from Cookies and Cookie Information
        and how we use it, detailed further in the{' '}
        <strong>“Your Rights”</strong> section, below.
      </>
    ),
  },
  {
    key: '8',
    textTitle: `VIII. Do Not Track Signals.`,
    content: (
      <>
        Some browsers send a “Do Not Track” signal to websites. Currently, we do
        not respond to Do Not Track signals.
      </>
    ),
  },
  {
    key: '9',
    textTitle: `IX. Your Rights`,
    content: (
      <>
        You have certain rights regarding your personal information. You may,
        for example:
        <ul>
          <li>Request access to your personal information;</li>
          <li>
            Request that we correct any inaccurate or incomplete personal
            information;
          </li>
          <li>Request that we delete your personal information;</li>
          <li>Object to the processing of your personal information;</li>
          <li>
            Request that we restrict the processing of your personal
            information;
          </li>
          <li>
            Request that we transfer your personal information to another
            company.
          </li>
        </ul>
        <br />
        To make any of these requests, please contact us at{' '}
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a>. We
        will respond as soon as possible.
        <br />
        <br />
        Unless you specifically ask us to delete your personal information, we
        may retain your personal information as long as it is necessary to
        comply with our data retention requirements and/or as required by law.
        Even if you submit a deletion request, we may be required to maintain
        your personal information for as long as necessary to:
        <ul>
          <li>comply with our legal or regulatory compliance needs;</li>
          <li>to exercise, establish, or defend legal claims; and/or</li>
          <li>
            to protect against fraudulent or abusive activity on our Site.
          </li>
        </ul>
        <br />
        There may be occasions where we are unable to fully delete, anonymize,
        or de-identify your personal information due to technical, legal,
        regulatory compliance, or other operational reasons. Where this is the
        case, we will take reasonable measures to securely isolate your personal
        information from any further processing until such time as we are able
        to delete, anonymize, or de-identify it.
        <br />
        <br />
        Additionally, if you are a citizen of the State of, e.g., California,
        Colorado, Connecticut, Virginia, or Utah, then you may have additional
        privacy lights that are not listed herein, including, e.g., the right to
        correction and deletion; the right to access all privacy information of
        yours that we have collected, etc. You are encouraged to research the
        privacy rights and protections that may be applicable to you—regardless
        of your state of domicile—and to stay apprised of such rights.
        <br />
        <br />f you have any explicit questions about such rights or wish to
        enforce any of your legal rights, please contact us at{' '}
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a> with
        as much specificity and detail as possible, and we would be happy to
        assist you.
      </>
    ),
  },
  {
    key: '10',
    textTitle: `X. Data Protection Rights of International Users.`,
    content: (
      <>
        If you are accessing the Services from outside the United States, then
        you may have additional data protection rights not explicitly listed
        herein. If you are accessing the Services from within Europe (including,
        for purposes herein, the United Kingdom and the European Economic
        Area),then the Data Protection Act, General Data Protection Regulation,
        and similar statutes (collectively, for purposes herein,{' '}
        <strong>“GDPR”</strong>) may provide you with additional privacy
        protections and options regarding your personal identifiable information
        (<strong>“PII”</strong>), some of which are summarized herein for your
        convenience
        <br />
        <br />
        Specifically, the GDPR applies to PII (such as, e.g., your name,
        address, email address, IP address, payment details, etc.), and the
        Company, as the data collector, must have a “lawful reason” for storing
        or using such personal data, including, for example:
        <ul>
          <li>
            (i) consent (you have consented to the Company having your data);
          </li>
          <li>
            (ii) contractual reasons (collection and storage of the personal
            data is required for contractual performance); and
          </li>
          <li>
            (iii) it is necessary for the Company to use and store such PII for
            its “legitimate interest”.
          </li>
        </ul>
        <br />
        With the aforementioned criteria in mind, by using the Services, you
        explicitly grant the Company the ability to use, access, and store your
        PII in accordance with the GDPR. Notwithstanding the foregoing, due to
        the nature of the Company’s Services, the Company also has a “legitimate
        interest”, as detailed in the GDPR, to collect such PII and to use and
        store it in accordance with applicable law, our legitimate business
        purposes, and/or your expectations regarding the Services.
        <br />
        <br />
        Despite its rights under the GDPR, the Company endeavors to minimize the
        amount of PII that it actually obtains or collects in the performance of
        its Services.
        <br />
        <br />
        Additionally, you may have data protection and privacy rights pursuant
        to your Data Subject Access Rights under the GDPR, which may permit you
        to, e.g., withdraw consent, request a copy of your data, or request
        deletion of your data.
        <br />
        <br />
        If you would like to do any of the aforementioned options, please e-mail
        us at
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a> and
        we will respond accordingly. Please note that a request to, e.g.,
        withdraw consent or delete your data may affect your use of the
        Services, including potential ability to access the Services.
        <br />
        <br />
        The Company shall retain your PII for as long as the Company maintains a
        legitimate interest in or need for such data or as long as applicable
        law permits, whichever is longer. If you have any questions about your
        PII, the information that the Company has collected from you, or if you
        wish to exercise any of your rights under the GDPR or similar,
        applicable international law, please e-mail the company at
        Legal@TippingGuide.com.
      </>
    ),
  },
  {
    key: '11',
    textTitle: `XI. Security.`,
    content: (
      <>
        We take security measures to protect your personal information from
        unauthorized access, use, disclosure, alteration, or destruction. These
        measures include, e.g.:
        <ul>
          <li>
            Access controls to limit who can access your personal information;
          </li>
          <li>
            Encryption of personal information during storage or transmission;
          </li>
          <li>Regular monitoring of our security systems and procedures.</li>
        </ul>
        <br />
        Accordingly, we use reasonable physical, technical, and organizational
        safeguards that are designed to protect your personal information.
        However, despite these controls, we cannot completely ensure or warrant
        the security of your personal information, and we explicitly disclaim
        any and all liability related to damages, losses, and issues related to
        or arising from your use of the Site or Services.
      </>
    ),
  },
  {
    key: '12',
    textTitle: `XII. Changes to This Policy.`,
    content: (
      <>
        We reserve the right to change the terms and conditions of this Privacy
        Policy at any time and in our sole discretion. You are responsible for
        checking, and explicitly agree to periodically check, the Agreement from
        time to time for any changes. The Company will endeavor, but shall not
        be obligated, to provide thirty (30) days prior notice of any material
        change. Notice may be provided in writing, electronically, or via the
        Site. If you do not wish to be bound by such change, you may discontinue
        using and terminate the Services before the changes become effective. If
        you continue to use the Services after the changes become effective, you
        will be bound by the changes.
      </>
    ),
  },
  {
    key: '13',
    textTitle: `XIII. Site and Services Not Intended for Minors.`,
    content: (
      <>
        The Site and Services are not intended for or directed to individuals
        under the age of 18.
        <br />
        <br />
        We do not knowingly collect personal information from minors. If you
        believe we may have inadvertently collected information from a minor,
        please contact us at{' '}
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a>.
      </>
    ),
  },
  {
    key: '14',
    textTitle: `XIV. Liability Waiver.`,
    content: (
      <>
        By using our Site or Services, you explicitly agree to the terms in this
        Privacy Policy. Accordingly, you agree to release and forever discharge
        us from any claims that may arise from any service rendered or provided
        by us to you.
      </>
    ),
  },
  {
    key: '15',
    textTitle: `XV. Contact Us.`,
    content: (
      <>
        If you have any questions about this Privacy Policy or the Agreement in
        general, please contact us at:
        <br />
        <br />
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a>
      </>
    ),
  },
];

export default function PrivacyPolicyContent(): React.ReactElement {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <h2>TIPPING GUIDE LLC - PRIVACY POLICY</h2>

            <ul>
              <p>Last Updated: March 19, 2025</p>

              {textContent.map((item) => (
                <li className={styles.subTitle} key={item.key}>
                  <p>
                    <strong>{item.textTitle}</strong>
                  </p>
                  <div className={styles.text}>
                    <span className={styles.text}>{item.content}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <JoinOurCommunity />
    </>
  );
}
